import React, { useEffect } from 'react';
import heroimage from '../assets/images/heroimage.png';
import entrepreneurship from '../assets/images/entrepreneurship.jpg';
import innovation from '../assets/images/innovation.jpg';
import technology from '../assets/images/technology.jpg';
import marketing from '../assets/images/marketing.jpg';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { TypeAnimation } from 'react-type-animation';
import Client1 from '../assets/images/centralRoofing.png';
import Client2 from '../assets/images/gml.png';
import Client3 from '../assets/images/BuahAssociates.png';

const offerings = [
  { img: technology,       title: 'Commercial IT Services',                link: '/services#its',  desc: 'Software, web, mobile & desktop solutions.' },
  { img: entrepreneurship, title: 'Vocational & Entrepreneurship Training', link: '/services#vets', desc: 'Expert-led programs to launch your venture.' },
  { img: innovation,       title: 'Venture Capital Services',               link: '/services#vcs',  desc: 'Connecting promising ideas with investors.' },
  { img: marketing,        title: 'Marketing Services',                     link: '/services#mkts', desc: 'Creative digital marketing for your brand.' },
];

const stats = [
  { num: '70+', label: 'Satisfied Clients',  sub: "Businesses we've helped grow",  bg: 'bg-blueblack', numColor: 'text-yellowcolor', labelColor: 'text-white',    subColor: 'text-white/40',    border: 'border-white/10' },
  { num: '50+', label: 'Projects Delivered', sub: 'On time, every time',           bg: 'bg-yellowcolor', numColor: 'text-blueblack', labelColor: 'text-blueblack', subColor: 'text-blueblack/60', border: 'border-blueblack/10' },
  { num: '25+', label: 'Apps Built',         sub: 'Web & mobile applications',     bg: 'bg-seablue',   numColor: 'text-white',     labelColor: 'text-white',    subColor: 'text-white/60',    border: 'border-white/10' },
];

export default function Home() {
  useEffect(() => {
    document.title = 'EIT Ghana Limited';
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.4 }}
    >

      {/* ── HERO BENTO ── */}
      <section className="min-h-screen bg-gray-50 pt-16 flex items-center">
        <div className="max-w-7xl mx-auto w-full px-5 lg:px-20 py-10">
          <div className="grid lg:grid-cols-12 gap-5 items-stretch">

            {/* Main text card */}
            <motion.div
              className="lg:col-span-7 bg-white rounded-3xl p-8 lg:p-12 shadow-sm flex flex-col justify-between gap-8"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.15, duration: 0.6 }}
            >
              <div className="flex flex-col gap-5">
                <span className="inline-flex items-center gap-2 bg-yellow-50 text-yellow-700 border border-yellow-100 px-4 py-1.5 rounded-full text-xs font-semibold w-fit">
                  <span className="w-2 h-2 bg-yellowcolor rounded-full animate-pulse" />
                  Ghana's Innovation Hub
                </span>

                <h1 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-blueblack leading-tight">
                  Empowering Ghana's{' '}
                  <span className="text-yellowcolor">
                    <TypeAnimation
                      sequence={['Entrepreneurs', 1500, 'Innovators', 1500, 'Businesses', 1500]}
                      wrapper="span"
                      speed={50}
                      repeat={Infinity}
                    />
                  </span>
                </h1>

                <p className="text-gray-500 text-lg leading-relaxed max-w-xl">
                  EIT Ghana Limited is your all-in-one hub for technology services, entrepreneurship
                  training, venture capital, and marketing solutions.
                </p>
              </div>

              <div className="flex flex-col gap-6">
                <div className="flex flex-wrap gap-3">
                  <Link
                    to="/services"
                    className="px-7 py-3 bg-blueblack text-white font-semibold rounded-full hover:bg-seablue transition-all duration-300 hover:shadow-lg hover:-translate-y-0.5"
                  >
                    Explore Services
                  </Link>
                  <Link
                    to="/about"
                    className="px-7 py-3 bg-gray-100 text-blueblack font-semibold rounded-full hover:bg-gray-200 transition-all duration-300"
                  >
                    Learn More
                  </Link>
                </div>

                <div className="flex gap-8 pt-6 border-t border-gray-100">
                  {stats.map(({ num, label }) => (
                    <div key={label}>
                      <div className="text-2xl font-bold text-blueblack">{num}</div>
                      <div className="text-xs text-gray-400 mt-0.5">{label}</div>
                    </div>
                  ))}
                </div>
              </div>
            </motion.div>

            {/* Right mini-bento */}
            <motion.div
              className="lg:col-span-5 flex flex-col gap-5"
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.3, duration: 0.6 }}
            >
              {/* Hero image card */}
              <div className="flex-1 bg-blueblack rounded-3xl overflow-hidden flex items-center justify-center p-8 min-h-[280px]">
                <img src={heroimage} alt="EIT Ghana" className="w-full max-w-xs object-contain drop-shadow-2xl" />
              </div>

              {/* Stat cards */}
              <div className="grid grid-cols-2 gap-5">
                <div className="bg-yellowcolor rounded-2xl p-6 flex flex-col gap-1.5">
                  <div className="text-3xl font-bold text-blueblack">70+</div>
                  <div className="text-xs font-semibold text-blueblack/70">Satisfied Clients</div>
                </div>
                <div className="bg-seablue rounded-2xl p-6 flex flex-col gap-1.5">
                  <div className="text-3xl font-bold text-white">50+</div>
                  <div className="text-xs font-semibold text-white/70">Projects Done</div>
                </div>
              </div>
            </motion.div>

          </div>
        </div>
      </section>

      {/* ── CAPABILITIES BENTO ── */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">

          <motion.div
            className="mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <p className="text-seablue font-semibold text-xs uppercase tracking-widest mb-2">What We Do</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-blueblack">Our Capabilities</h2>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">

            {/* Web Development – large, navy */}
            <motion.div className="col-span-2 bg-blueblack rounded-3xl p-8 flex flex-col gap-4"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ duration: 0.4 }} viewport={{ once: true }}>
              <div className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center text-2xl">💻</div>
              <h3 className="text-xl font-bold text-white">Web Development</h3>
              <p className="text-white/60 text-sm leading-relaxed">Modern, responsive websites and web applications built for performance and growth.</p>
            </motion.div>

            <motion.div className="bg-white rounded-3xl p-6 shadow-sm flex flex-col gap-3 border border-gray-50"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.05, duration: 0.4 }} viewport={{ once: true }}>
              <div className="w-10 h-10 bg-blue-50 rounded-xl flex items-center justify-center text-xl">📱</div>
              <h3 className="font-bold text-blueblack text-sm leading-tight">Mobile Development</h3>
              <p className="text-gray-400 text-xs">iOS & Android apps</p>
            </motion.div>

            <motion.div className="bg-yellow-50 rounded-3xl p-6 border border-yellow-100 flex flex-col gap-3"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.1, duration: 0.4 }} viewport={{ once: true }}>
              <div className="w-10 h-10 bg-yellowcolor/20 rounded-xl flex items-center justify-center text-xl">📊</div>
              <h3 className="font-bold text-blueblack text-sm leading-tight">Data Analysis</h3>
              <p className="text-gray-500 text-xs">Insights that drive decisions</p>
            </motion.div>

            <motion.div className="bg-white rounded-3xl p-6 shadow-sm flex flex-col gap-3 border border-gray-50"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.15, duration: 0.4 }} viewport={{ once: true }}>
              <div className="w-10 h-10 bg-green-50 rounded-xl flex items-center justify-center text-xl">📣</div>
              <h3 className="font-bold text-blueblack text-sm leading-tight">Digital Marketing</h3>
              <p className="text-gray-400 text-xs">Reach your audience</p>
            </motion.div>

            <motion.div className="bg-white rounded-3xl p-6 shadow-sm flex flex-col gap-3 border border-gray-50"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.2, duration: 0.4 }} viewport={{ once: true }}>
              <div className="w-10 h-10 bg-purple-50 rounded-xl flex items-center justify-center text-xl">🎨</div>
              <h3 className="font-bold text-blueblack text-sm leading-tight">Graphic Design</h3>
              <p className="text-gray-400 text-xs">Visual identity creation</p>
            </motion.div>

            {/* Entrepreneurship – large, seablue */}
            <motion.div className="col-span-2 bg-seablue rounded-3xl p-8 flex flex-col gap-4"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.1, duration: 0.4 }} viewport={{ once: true }}>
              <div className="w-12 h-12 bg-white/10 rounded-2xl flex items-center justify-center text-2xl">🚀</div>
              <h3 className="text-xl font-bold text-white">Entrepreneurship Training</h3>
              <p className="text-white/70 text-sm leading-relaxed">Expert-led programs to help you launch and grow your venture with confidence.</p>
            </motion.div>

            {/* Vocational – medium, spans 2 */}
            <motion.div className="col-span-2 bg-gray-50 rounded-3xl p-7 border border-gray-100 flex flex-col gap-3"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.25, duration: 0.4 }} viewport={{ once: true }}>
              <div className="w-10 h-10 bg-orange-50 rounded-xl flex items-center justify-center text-xl">🛠️</div>
              <h3 className="font-bold text-blueblack leading-tight">Vocational Training</h3>
              <p className="text-gray-500 text-sm">Practical skills programs designed to prepare you for the modern job market.</p>
            </motion.div>

            {/* Venture Capital – medium, spans 2 */}
            <motion.div className="col-span-2 bg-blueblack rounded-3xl p-7 flex flex-col gap-3"
              initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} transition={{ delay: 0.3, duration: 0.4 }} viewport={{ once: true }}>
              <div className="w-10 h-10 bg-yellowcolor/20 rounded-xl flex items-center justify-center text-xl">💰</div>
              <h3 className="font-bold text-yellowcolor leading-tight">Venture Capital</h3>
              <p className="text-white/50 text-sm">Connecting great ideas with the investors and funding they need to succeed.</p>
            </motion.div>

          </div>
        </div>
      </section>

      {/* ── WHAT WE OFFER ── */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">

          <motion.div
            className="mb-10"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <p className="text-seablue font-semibold text-xs uppercase tracking-widest mb-2">Services</p>
            <h2 className="text-3xl lg:text-4xl font-bold text-blueblack">What We Offer</h2>
          </motion.div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-5">
            {offerings.map(({ img, title, link, desc }, i) => (
              <motion.div
                key={title}
                className="group bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-1"
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.08, duration: 0.5 }}
                viewport={{ once: true }}
              >
                <div className="relative overflow-hidden h-48">
                  <img
                    src={img}
                    alt={title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-blueblack/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
                </div>
                <div className="p-6 flex flex-col gap-3">
                  <h3 className="font-bold text-blueblack text-sm leading-tight">{title}</h3>
                  <p className="text-gray-500 text-xs leading-relaxed">{desc}</p>
                  <HashLink
                    smooth
                    to={link}
                    className="inline-flex items-center gap-1 text-xs font-semibold text-seablue hover:text-blueblack transition-colors"
                  >
                    Learn More →
                  </HashLink>
                </div>
              </motion.div>
            ))}
          </div>

        </div>
      </section>

      {/* ── STATS BENTO ── */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {stats.map(({ num, label, sub, bg, numColor, labelColor, subColor, border }, i) => (
              <motion.div
                key={label}
                className={`${bg} rounded-3xl p-10 flex flex-col gap-4`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.1, duration: 0.5 }}
                viewport={{ once: true }}
              >
                <div className={`text-6xl lg:text-7xl font-bold ${numColor}`}>{num}</div>
                <div className={`border-t ${border} pt-4`}>
                  <div className={`${labelColor} font-semibold`}>{label}</div>
                  <div className={`${subColor} text-sm mt-1`}>{sub}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* ── CLIENTS ── */}
      <section className="py-16 bg-gray-50">
        <div className="max-w-7xl mx-auto px-5 lg:px-20">
          <motion.div
            className="bg-white rounded-3xl p-10 lg:p-14 shadow-sm"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            viewport={{ once: true }}
          >
            <div className="text-center mb-10">
              <p className="text-gray-400 text-xs uppercase tracking-widest font-semibold mb-2">Our Clients</p>
              <h2 className="text-2xl lg:text-3xl font-bold text-blueblack">Trusted By</h2>
            </div>
            <div className="flex flex-wrap justify-center items-center gap-12">
              {[Client1, Client2, Client3].map((logo, i) => (
                <img
                  key={i}
                  src={logo}
                  alt={`Client ${i + 1}`}
                  className="h-10 lg:h-14 object-contain grayscale hover:grayscale-0 opacity-50 hover:opacity-100 transition-all duration-300"
                />
              ))}
            </div>
          </motion.div>
        </div>
      </section>

    </motion.div>
  );
}
